<template>
  <div v-show="show">
    <slot />
  </div>
</template>

<script setup lang="ts">
import { provide, ref, unref, watch } from 'vue'
import type { TransitionApi } from './transitionApi'
import type { Props } from './props'

const props = defineProps<Props>()
const show = ref<TransitionApi['show']['value']>(unref(props.show))

const api: TransitionApi = {
  show,
  setShowTransitionValue(value: boolean) {
    show.value = value
  },
}

watch(
  () => props.show,
  (newValue) => {
    if (newValue)
      show.value = newValue
  },
)

provide('TransitionApi', api)
</script>
